export const socMedOptions = [
    {label: "ALL", value: "ALL"},
    {label: "ADA", value: "YES"},
    {label: "TIDAK ADA", value: "NO"},
];

export const prospekCategoryOptions = [
    {label: "H1", value: "H1"},
    {label: "H23", value: "H23"},
];

export const prospekTypeOptions = [
    {label: "NEW", value: "NEW"},
    {label: "RO H1", value: "RO_H1"},
    {label: "RO H23", value: "RO_H23"},
    {label: "XS H21", value: "XS_H21"},
    {label: "XS H21P", value: "XS_H21P"},
];

export const prospekSourceOptions = [
    {label: "CRM", value: "CRM"},
    {label: "Showroom", value: "SHOWROOM"},
    {label: "Kanvas", value: "KANVAS"},
    {label: "Pameran", value: "PAMERAN"},
    {label: "MedSos", value: "MEDSOS"},
];

export const operatorOptions = [
    {label: "<", value: "<"},
    {label: "<=", value: "<="},
    {label: "=", value: "="},
    {label: ">=", value: ">="},
    {label: ">", value: ">"},
];

export const memberLevelOptions = [
    {label: "GOLD", value: "GOLD"},
    {label: "SILVER", value: "SILVER"},
];

export const loyaltyLevelOptions = [
    {label: "BUYER", value: "BUYER"},
    {label: "CUSTOMER", value: "CUSTOMER"},
    {label: "ADVOKAT", value: "ADVOCATE"},
];

export const specialCategoryOptions = [
    {label: null, value: ""},
    {label: "Pembawa", value: "PEMBAWA"},
    {label: "Makelar", value: "MAKELAR"},
    {label: "Affiliate", value: "AFFILIATE"},
];

export const fuStatus = [
    {label: "ONGOING", value: "ONGOING"},
    {label: "PENDING", value: "PENDING"},
    {label: "DROP", value: "DROP"},
    // {label: "DEAL", value: "DEAL"},
    {label: "DEATH", value: "DEATH"},
    // {label: "INDENT", value: "INDENT"},
];

export const fuBy = [
    {label: "TELEPON", value: "TELEPON"},
    {label: "WA CALL", value: "WA_CALL"},
    {label: "WA CHAT", value: "WA_CHAT"},
    {label: "VISIT", value: "VISIT"},
    {label: "MEDSOS", value: "MEDSOS"},
];

export const connected = [
    {label: "YES", value: true},
    {label: "NO", value: false},
];